<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_PM.id==0">فرم ثبت اطلاعات </h5>
    <h5 class="card-title" *ngIf="inner_PM.id>0">فرم ویرایش اطلاعات  </h5>
    <br>
    <br>

    <form [formGroup]="PMForm" >

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input formControlName="Title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">روز</label>
          <input formControlName="Duration" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Duration().valid && get_Form_Duration().touched"
            class="form-text text-muted MyErrorRedColor">روز را وارد نمائید.</small>
        </div>


      </div>
    </form>

    <br />
    <hr />
    <br />


    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

    <button *ngIf="!InProccessing && inner_PM.id==0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>

    <button *ngIf="!InProccessing && inner_PM.id>0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ویرایش اطلاعات </button>

  </div>
</div>
